(() => {
  'use strict';
  let config;
  try { config = JSON.parse(document.querySelector('[data-outlet-duo-config]').textContent); }
  catch { return; }
  const start = Date.parse(config.startsAt), end = Date.parse(config.endsAt);
  const ids = new Set((config.eligibleVariantIds || []).map(String));
  const current = () => Date.now() >= start && Date.now() < end;
  if (config.enabled !== true || config.discountVerified !== true ||
      config.code !== 'DUO60' || config.amountMinor !== 6000 || config.currency !== 'MAD' ||
      config.minimumEligiblePairs !== 2 || config.nonCombinable !== true ||
      config.usageLimit !== 10 || config.appliesOncePerCustomer !== true ||
      !Number.isFinite(start) || !Number.isFinite(end) || end <= start ||
      !current() || ids.size === 0 || window.armadoxDuoInitialized) return;
  window.armadoxDuoInitialized = true;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const expiry = '11 octobre 2026 à 12 h 40';
  const conditions = 'Dès 2 paires éligibles. 60 DH de remise au total, une seule fois par client. ' +
    'Non cumulable. Offre limitée à 10 utilisations, jusqu’au ' + expiry +
    ' (heure du Maroc), selon les disponibilités. Validation au paiement.';
  const discountLink = destination => {
    const link = new URL((window.Shopify?.routes?.root || '/') + 'discount/DUO60', location.origin);
    link.searchParams.set('redirect', destination.pathname + destination.search);
    return link.pathname + link.search;
  };
  const root = document.getElementById('ax-outlet');
  if (root) {
    if ((root.dataset.currency || 'MAD') !== 'MAD') return;
    let products;
    try { products = JSON.parse(root.querySelector('[data-outlet-data]').textContent); }
    catch { return; }
    if (!Array.isArray(products)) return;
    const variants = new Map(products.flatMap(product => product.variants || [])
      .filter(variant => ids.has(String(variant.id)) && variant.qty > 0)
      .map(variant => [String(variant.id), variant]));
    if ([...variants.values()].reduce((sum, variant) => sum + variant.qty, 0) < 2) return;
    const grid = root.querySelector('[data-outlet-grid]');
    const hero = root.querySelector('.ax-outlet__hero');
    if (!grid || !hero) return;
    const panel = make('aside', 'ax-duo');
    panel.setAttribute('aria-labelledby', 'ax-duo-title');
    const copy = make('div', 'ax-duo__copy');
    const title = make('h2', '', 'Deux paires. 60 DH de moins.');
    title.id = 'ax-duo-title';
    copy.append(make('p', 'ax-duo__eyebrow', 'VOTRE DUO OUTLET'), title,
      make('p', '', 'Choisissez deux paires marquées « DUO60 » et profitez de 60 DH de remise avec le code DUO60.'),
      make('p', 'ax-duo__terms', conditions));
    const action = make('a', 'ax-duo__activate', 'Activer DUO60');
    const updateLink = () => {
      const destination = new URL(location.href);
      destination.hash = 'ax-outlet';
      action.href = discountLink(destination);
    };
    action.addEventListener('click', updateLink);
    updateLink();
    panel.append(copy, action);
    hero.insertAdjacentElement('afterend', panel);
    // One bounded selection aid; no new offer, cart action or price mutation.
    const comparisonNotBefore = Date.parse('2026-10-05T14:20:05Z');
    const comparisonPairs = {
      '44': ['51670054273334', '51453727539510'],
      '39': ['51453727375670', '51453727637814']
    };
    const comparisonRecords = new Map(products.flatMap(product =>
      (product.variants || []).map(variant => [String(variant.id), { product, variant }])));
    const comparison = make('section', 'ax-duo-comparison');
    comparison.hidden = true;
    comparison.setAttribute('aria-labelledby', 'ax-duo-comparison-title');
    comparison.setAttribute('data-outlet-duo-comparison', '');
    const comparisonAnchor = root.querySelector('.ax-outlet__controls');
    comparisonAnchor?.insertAdjacentElement('afterend', comparison);
    let comparisonSignature = '';
    const comparisonMoney = value => new Intl.NumberFormat('fr-MA', {
      minimumFractionDigits: 0, maximumFractionDigits: 2
    }).format(value / 100) + ' DH';
    function updateComparison() {
      const selected = root.querySelector('[data-outlet-sizes] button[aria-pressed="true"]')?.dataset.size;
      const selectedPair = comparisonPairs[selected];
      const visibleIds = new Set([...grid.querySelectorAll('select[name="id"] option')].map(option => option.value));
      const entries = selectedPair?.map(id => comparisonRecords.get(id));
      const ready = comparisonAnchor && Date.now() >= comparisonNotBefore && current() &&
        entries?.length === 2 && entries.every(entry => entry &&
          ids.has(String(entry.variant.id)) && visibleIds.has(String(entry.variant.id)) &&
          String(entry.variant.size) === selected && entry.variant.qty >= 1 &&
          Number.isSafeInteger(entry.variant.price) && entry.variant.price > 0);
      if (!ready) { comparison.hidden = true; comparisonSignature = ''; return; }
      const destinations = entries.map(entry => {
        try {
          const url = new URL(entry.product.url, location.origin);
          if (url.origin !== location.origin || !url.pathname.includes('/products/')) return null;
          url.searchParams.set('variant', entry.variant.id);
          return url.pathname + url.search;
        } catch { return null; }
      });
      if (destinations.some(url => !url)) { comparison.hidden = true; comparisonSignature = ''; return; }
      const subtotal = entries.reduce((sum, entry) => sum + entry.variant.price, 0);
      if (subtotal <= config.amountMinor) { comparison.hidden = true; comparisonSignature = ''; return; }
      const signature = JSON.stringify([selected, entries.map(entry => [entry.variant.id, entry.variant.price, entry.variant.qty]), destinations]);
      if (signature === comparisonSignature && !comparison.hidden) return;
      comparisonSignature = signature;
      comparison.replaceChildren();
      comparison.dataset.pointure = selected;
      const heading = make('h2', 'ax-duo-comparison__title', 'Deux paires dans votre pointure.');
      heading.id = 'ax-duo-comparison-title';
      comparison.append(heading, make('p', 'ax-duo-comparison__intro', 'Pointure ' + selected + ' · Deux choix éligibles à DUO60.'));
      const choices = make('div', 'ax-duo-comparison__choices');
      entries.forEach((entry, index) => {
        const choice = make('a', 'ax-duo-comparison__choice');
        choice.href = destinations[index];
        choice.setAttribute('data-outlet-duo-comparison-variant', String(entry.variant.id));
        const image = make('img');
        image.src = entry.variant.image || entry.product.image;
        image.alt = entry.product.title + ' — ' + entry.variant.title;
        image.width = 88; image.height = 88; image.loading = 'lazy'; image.decoding = 'async';
        const details = make('span', 'ax-duo-comparison__choice-copy');
        details.append(make('strong', '', entry.product.title),
          make('span', '', entry.variant.title),
          make('span', 'ax-duo-comparison__price', comparisonMoney(entry.variant.price)),
          make('span', 'ax-duo-comparison__view', 'Voir cette paire'));
        choice.append(image, details); choices.append(choice);
      });
      comparison.append(choices,
        make('p', 'ax-duo-comparison__sum', comparisonMoney(subtotal) + ' pour ces 2 paires − 60 DH avec DUO60'),
        make('p', 'ax-duo-comparison__total', 'Total avec DUO60 : ' + comparisonMoney(subtotal - config.amountMinor)),
        make('p', 'ax-duo-comparison__note', 'Même offre DUO60, selon les conditions ci-dessus. Remise confirmée au paiement.'));
      comparison.hidden = false;
    }
    function markCards() {
      const active = current();
      panel.hidden = !active;
      for (const card of grid.querySelectorAll('.ax-outlet__card')) {
        const select = card.querySelector('select[name="id"]');
        const matches = active && select && variants.has(select.value);
        let badge = card.querySelector('[data-outlet-duo-badge]');
        if (!matches) { badge?.remove(); continue; }
        if (!badge) {
          badge = make('p', 'ax-duo__badge', 'DUO60 · Paire éligible');
          badge.setAttribute('data-outlet-duo-badge', '');
          card.querySelector('.ax-outlet__money')?.insertAdjacentElement('afterend', badge);
        }
      }
      updateComparison();
    }
    const observer = new MutationObserver(markCards);
    observer.observe(grid, { childList: true });
    root.addEventListener('change', markCards);
    document.addEventListener('visibilitychange', markCards);
    window.addEventListener('pageshow', markCards);
    const timer = setInterval(() => {
      markCards();
      if (!current()) { clearInterval(timer); observer.disconnect(); }
    }, 30000);
    markCards();
  }
  const cart = document.getElementById('MinimogCart');
  if (cart) {
    let signature = '';
    function updateCart() {
      const data = cart.querySelector('[data-outlet-duo-cart]');
      const raw = data?.textContent || '';
      const active = current();
      if (signature === active + ':' + raw && cart.querySelector('[data-outlet-duo-return]')) return;
      signature = active + ':' + raw;
      cart.querySelector('[data-outlet-duo-return]')?.remove();
      if (!active || !data || data.dataset.currency !== 'MAD') return;
      let lines;
      try { lines = JSON.parse(raw); } catch { return; }
      if (!Array.isArray(lines)) return;
      const eligible = lines.filter(line => ids.has(String(line.id)) && line.quantity > 0);
      const quantity = eligible.reduce((sum, line) => sum + line.quantity, 0);
      if (quantity < 1) return;
      const box = make('aside', 'ax-duo-cart');
      box.setAttribute('data-outlet-duo-return', '');
      const lead = quantity === 1 ? 'Votre première paire est éligible à DUO60.' : 'Votre sélection contient au moins deux paires éligibles à DUO60.';
      box.append(make('p', 'ax-duo-cart__title', lead));
      const destination = new URL((window.Shopify?.routes?.root || '/') + 'collections/outlet', location.origin);
      const selectedSizes = [...new Set(eligible.map(line => String(line.size)))];
      if (selectedSizes.length === 1 && /^(3[8-9]|4[0-6])$/.test(selectedSizes[0])) destination.searchParams.set('pointure', selectedSizes[0]);
      destination.hash = 'ax-outlet';
      const back = make('a', 'ax-duo-cart__return', quantity === 1 ? 'Choisir ma deuxième paire Outlet' : 'Voir les autres paires Outlet');
      back.href = destination.pathname + destination.search + destination.hash;
      box.append(back);
      if (quantity >= 2) {
        const apply = make('a', 'ax-duo-cart__apply', 'Appliquer le code DUO60');
        apply.href = discountLink(new URL((window.Shopify?.routes?.root || '/') + 'cart', location.origin));
        box.append(apply);
      }
      box.append(make('p', 'ax-duo-cart__terms', conditions));
      data.insertAdjacentElement('afterend', box);
    }
    const observer = new MutationObserver(updateCart);
    observer.observe(cart, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', updateCart);
    window.addEventListener('pageshow', updateCart);
    const timer = setInterval(() => {
      updateCart();
      if (!current()) { clearInterval(timer); observer.disconnect(); }
    }, 30000);
    updateCart();
  }
})();
